<template>
  <section class="exhibition">
    <!-- <div class="title">
      <h2 class="content">博客详情</h2>
    </div> -->
    <div class="section">
      <div class="container">
        <div class="item details">
          <div class="details-img">
            <img :src="banner" class="image">
            <div class="date">
              {{year}}
              <br>
              {{month}}/{{day}}
            </div>
          </div>
          <div class="content">
            <h2 class="title">{{title}}</h2>
            <iframe :src="newsPageSrc" width="100%" scrolling="no" frameborder="0" @load="resizeIframe"></iframe>
            <!-- <ul class="content-category">
              <li><a href="#">计算机</a></li>
              <li><a href="#">移动</a></li>
              <li><a href="#">市场营销</a></li>
              <li><a href="#">设计</a></li>
              <li><a href="#">发展</a></li>
            </ul>
            <h3 class="content-title">如何成为一名在家工作的专业人士</h3>
            <p class="content-describe">首先要深入掌握本专业的知识技能，其次要在这个专业工作，并且取得优秀的业绩第三要凭着自己的知识技能和业绩，成为本专业的领军人物</p>
            <p class="content-describe">
              成为一个专业人士需要具备专业精神，专业精神是指能够胜任一个岗位的职业功能，并且能够主动参与、投入到工作当中，对于细节方面都有深入的了解
              和把控。百年长存的企业真是那些对着自己产品的品质有这精益求精的精神，不断的根据行业的发展传承与改进，追求极致不断精挑细琢，这需要以极大的热爱之情去坚持，对工作的敬畏之情去奉献。
            </p>
            <p class="content-describe">
              做一名专业人士，意味着在做任何工作时都要尽一切努力实现预期结果。同时，也意味着要对自己的表现负责。
              作为一名专业人士，最重要的是要自己监督自己——也可以叫做自我质量控制。
            </p>
            <p class="content-block">
              做一名专业人士，意味着在做任何工作时都要尽一切努力实现预期结果。同时，也意味着要对自己的表现负责。
              作为一名专业人士，最重要的是要自己监督自己——也可以叫做自我质量控制。
            </p>
            <p class="content-describe">
              成为一个专业人士需要具备专业精神，专业精神是指能够胜任一个岗位的职业功能，并且能够主动参与、投入到工作当中，对于细节方面都有深入的了解
              和把控。百年长存的企业真是那些对着自己产品的品质有这精益求精的精神，不断的根据行业的发展传承与改进，追求极致不断精挑细琢，这需要以极大的热爱之情去坚持，对工作的敬畏之情去奉献。
            </p>
            <div class="content-share">
              <ul>
                <li><a href="#"><v-icon name="archive"/></a></li>
                <li><a href="#"><v-icon name="asterisk"/></a></li>
                <li><a href="#"><v-icon name="heart"/></a></li>
                <li><a href="#"><v-icon name="bookmark"/></a></li>
              </ul>
            </div>-->
          </div> 
        </div>
        <!-- <div class="item button">
          <div>
            <a href="#"  class="post left">上一张卡片</a>
          </div>
          <div>
            <a href="#"  class="post right">下一张卡片</a>
          </div>
        </div>
        <div class="item comments">
          <h3 class="comments-title">评论区</h3>
          <div class="single-comment">
            <div class="comment-img">
              <img src="../../assets/img/person.jpg">
            </div>
            <div class="comment-content">
              <h4 class="comment-content-title">约翰史密斯</h4> 
              <p class="comment-content-detail">
                影片名为《何以为家》，表面上看，是一个12岁的流浪少年渴望有个家、渴望有父母之爱，却又在得不到后憎恶家、逃离家的故事。但其所反映出的社会问题令人唏嘘不已，
                战争的阴影随处可见，孩子们过着朝不保夕的童年，他们的遭遇令人揪心，令人感伤。看完之后，我们都有一个共同的心愿，那就是影片最后打出的字幕：愿每个孩子都被温柔以待。
              </p>
              <span class="comment-content-date">01/19/2018 - 9:10AM</span>
              <a href="#" class="comment-content-reply">回复</a>
            </div>
          </div>
          <div class="single-comment unique">
            <div class="comment-img">
              <img src="../../assets/img/person5.jpg">
            </div>
            <div class="comment-content">
              <h4 class="comment-content-title">约翰大卫</h4> 
              <p class="comment-content-detail">
                影片名为《何以为家》，表面上看，是一个12岁的流浪少年渴望有个家、渴望有父母之爱，却又在得不到后憎恶家、逃离家的故事。但其所反映出的社会问题令人唏嘘不已，
                战争的阴影随处可见，孩子们过着朝不保夕的童年，他们的遭遇令人揪心，令人感伤。看完之后，我们都有一个共同的心愿，那就是影片最后打出的字幕：愿每个孩子都被温柔以待。
              </p>
              <span class="comment-content-date">01/19/2018 - 9:10AM</span>
              <a href="#" class="comment-content-reply">回复</a>
            </div>
          </div>
          <div class="single-comment">
            <div class="comment-img">
              <img src="../../assets/img/people6.jpg">
            </div>
            <div class="comment-content">
              <h4 class="comment-content-title">史蒂芬</h4> 
              <p class="comment-content-detail">
                影片名为《何以为家》，表面上看，是一个12岁的流浪少年渴望有个家、渴望有父母之爱，却又在得不到后憎恶家、逃离家的故事。但其所反映出的社会问题令人唏嘘不已，
                战争的阴影随处可见，孩子们过着朝不保夕的童年，他们的遭遇令人揪心，令人感伤。看完之后，我们都有一个共同的心愿，那就是影片最后打出的字幕：愿每个孩子都被温柔以待。
              </p>
              <span class="comment-content-date">01/19/2018 - 9:10AM</span>
              <a href="#" class="comment-content-reply">回复</a>
            </div>
          </div>
          <div class="single-comment">
            <div class="comment-img">
              <img src="../../assets/img/people7.jpg">
            </div>
            <div class="comment-content">
              <h4 class="comment-content-title">贺兰</h4> 
              <p class="comment-content-detail">
                影片名为《何以为家》，表面上看，是一个12岁的流浪少年渴望有个家、渴望有父母之爱，却又在得不到后憎恶家、逃离家的故事。但其所反映出的社会问题令人唏嘘不已，
                战争的阴影随处可见，孩子们过着朝不保夕的童年，他们的遭遇令人揪心，令人感伤。看完之后，我们都有一个共同的心愿，那就是影片最后打出的字幕：愿每个孩子都被温柔以待。
              </p>
              <span class="comment-content-date">01/19/2018 - 9:10AM</span>
              <a href="#" class="comment-content-reply">回复</a>
            </div>
          </div>
        </div>
        <div class="item reply">
          <h3 class="reply-title">留言</h3>
          <div class="form">
            <div class="first">
              <input type="text" class="formItem" placeholder="请输入姓名" :class="{ active: nameActive }" @focus="nActive" @blur="nameActive=false">
              <input type="email" class="formItem right" placeholder="请输入邮箱" :class="{ active: emailActive }" @focus="eActive" @blur="emailActive=false">
            </div>
            <div class="second">
              <textarea cols="30" rows="5" class="formItem" placeholder="请填写你的评论" :class="{ active: textActive }" @focus="tActive" @blur="textActive=false"></textarea>
            </div>
            <div class="btn">
              <button class="primary-btn" :class="{ active: btnActive }" @click='btnClick'>提交</button>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NewsDetails',
  data() {
    return {
      nameActive: false,
      emailActive: false,
      textActive: false,
      btnActive: false,
      newsPageSrc: '',
      title: '',
      banner: '',
      year: '',
      month: '',
      day: ''
    }
  },
  methods: {
    nActive() {
      this.nameActive = true
    },
    eActive() {
      this.emailActive = true
    },
    tActive() {
      this.textActive = true
    },
    btnClick() {
      this.btnActive = true
    },
    resizeIframe(event) {
      let iframe = event.target
      let iframeHeight = iframe.contentWindow.document.documentElement.scrollHeight + 'px'
      iframe.style.height = iframeHeight
    }
  },
  mounted () {
      let data = JSON.parse(localStorage.getItem('currentNews'))
      this.title = data.title
      this.newsPageSrc = data.page
      this.banner = data.banner
      let date = new Date(data.date)
      this.year = date.getFullYear()
      this.month = date.getMonth() + 1
      this.day = date.getDate()
  }
}
</script>

<style lang="scss" scoped>
a {
  transition: .5s;
  text-decoration: none;
}

p {
  color: #6084a4;
  line-height: 1.9;
}

ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.exhibition {
  width: 100%;
  margin: 0 auto;
  
  @media (max-width: 1024px) {
    width: 100%;
  }
}

.title {
  text-align: center;
}

.section {
  width: 100%;
  padding: 80px 0;
  
  @media (max-width: 745px) {
    padding: 50px 0;
  }

   @media (max-width: 1024px) {
    width: 100%;
  }
}

.container {
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  width: 100%;
  padding: 0 15px;
  box-sizing: border-box;
  margin: 0 auto;

  .item {
    width: 940px;
    box-sizing: border-box;
    box-shadow: 0 5px 10px rgba(0,9,128,0.035), 0 7px 18px rgba(0, 9, 128, 0.05);
  }

  .details {

    .details-img {
      position: relative;

      .image {
        width: 940px;
        height: 400px;
        object-fit: cover;
      }

      .date {
        position: absolute;
        width: 100px;
        height: 82px;
        border-radius: 5px;
        background: #44ce6f;
        bottom: 15px;
        right: 15px;
        text-align: center;
        font-size: 24px;
        color: #fff;
        font-style: italic;
        padding-top: 18px;
        line-height: 30px;
      }
    }

    .content {
      padding: 30px;
      text-align: left;

      .content-category {
        margin-bottom: 25px;

        li {
          display: inline-block;
          margin-right: 5px;

          a {
            display: inline-block;
            height: 29px;
            padding: 0 15px 0;
            background: #44ce6f;
            color: #fff;
            font-size: 14px;
            border-radius: 3px;
            line-height: 29px;
          }
        }
      }

      .content-title {
        color: #0e314c;
        font-weight: 500;
        margin: 0 0 8px;
        font-size: 16px;
      }

      .content-describe {
        font-size: 14px;
        margin: 18px 0 0;
      }

      .content-block {
        margin: 20px 0;
        padding: 25px;
        border-left: 4px solid #44ce6f;
        font-size: 17px;
      }

      .content-share {
        display: flex;
        justify-content: center;
        margin-top: 30px;

        li {
          display: inline-block;
          margin-right: 5px;
          text-align: center;

           a {
            display: inline-block;
            width: 38px;
            height: 38px;
            border: 1px solid #eee;
            color: #0e314c;
            border-radius: 50%;
            line-height: 40px;

            &:hover {
              color: #fff;
              background: #44ce6f;
            }
          }
        }
      }
    }
  }

  .button {
    display: flex;
    justify-content: space-between;
    margin: 25px 0;
    padding: 30px;

    .post {
      display: inline-block;
      line-height: 21px;
      border: 1px solid #eee;
      border-radius: 5px;
      padding: 8px 20px;
      color: #0e314c;
      font-size: 14px;

      &:hover {
        color: #fff;
        background: #44ce6f;
      }
    }
  }

  .comments {
    padding: 30px;

    .comments-title {
      margin: 0;
      text-align: left;
      color: #0e314c;
      font-weight: 500;
      font-size: 16px;
    }

    .single-comment {
      display: flex;
      position: relative;
      padding-left: 95px;
      margin-top: 30px;

      .comment-img {
        position: absolute;
        top: 0;
        left: 0;

        img {
          width: 75px;
          height: 75px;
          border-radius: 50%;
        }
      }

      .comment-content {
        position: relative;
        text-align: left;
        font-size: 14px;

        .comment-content-title {
          margin: 0 0 10px;
          color: #0e314c;
        }

        .comment-content-detail {
          margin: 0 0 15px;
        }

        .comment-content-date {
          color: #6084a4;
        }

         .comment-content-reply {
          position: absolute;
          right: 0;
          color: #0e314c;

          &:hover {
            color: #44ce6f;
          }
        }
      }
    }

    .unique {
      margin-left: 85px;
    }
  }

  .reply {
    margin-top: 25px;
    padding: 30px;

    .reply-title {
      color: #0e314c;
      font-weight: 500;
      font-size: 16px;
      margin: 0 0 30px;
      text-align: left;
    }

    .form {

      .first {
        display: flex;

        .formItem {
          height: 28px;
          flex: 0.5;

          // &:nth-child(2) {
          //   margin: 0 0 15px 15px;
          // }
        }

        .right {
          margin: 0 0 15px 15px;
        }
      }

      .second {
        display: flex;

        .formItem {
          height: 105px;
          flex: 1;
          margin: 0 0 15px 0;
          resize: vertical;
        }
      }

      .formItem {
        outline: none;
        margin: 0 15px 15px 0;
        padding: 10px 20px;
        border: 1px solid #eee;
        font-size: 14px;
        color: #0e314c;
        background: #eee;
        transition: .5s;
      }

      .btn {
        text-align: left;

        .primary-btn {
          position: relative;
          outline: none;
          color: #fff;
          font-size: 14px;
          padding: 15px 40px;
          background: #44ce6f;
          border: none;
          border-radius: 4px;
          font-weight: 600;
          cursor: pointer;
          transition: .5s;
          box-shadow: 0 13px 27px 0 rgba(68, 206, 111, 0.25);

          &:hover {
            transform: translateY(-3px);
            background: #343a40;

            &::before {
              width: 54px;
              left: 0;
              border-radius: 4px 0 0 4px;
            }

            &::after {
              width: 54px;
              right: 0;
              border-radius: 0 4px 4px 0;
            }
          }

          &::before, &::after {
            content: '';
            position: absolute;
            top: 0;
            height: 100%;
            width: 0;
            background: #c679ec;
            transition: .5s;
            z-index: -1;
            border-radius: 4px;
          }

          &::before {
            left: 0;
          }

          &::after {
            right: 0;
          }
        }

        .active {
          background: #343a40;
          transform: translateY(-3px);
        }
      }

      .active {
        background: #fff;
        border: 1px solid #44ce6f;
      }
    }
  }

  @media (max-width: 745px) {
    .item {
      width: 100%;

      &:not(:nth-child(1)) {
        padding: 30px 20px;
      }
    }

    .details {
      .content {
        padding: 30px 20px;
      }

      .content-category {
        li {
          margin-bottom: 5px;
        }
      }
    }

    .reply {
      .form {

        .first {
          display: flex;
          flex-flow: column;

          .formItem {
            flex: 1; 
            margin: 0 0 18px;
          }
        }

        .second {
          .formItem {
            margin: 0 0 18px;
          }
        }
      }
    }

    .comments {

      .single-comment {
        display: flex;
        flex-flow: column;
        align-items: flex-start;
        width: 100%;
        padding: 0;

        .comment-img {
          position: relative;
          margin-bottom: 25px;
        }
      }

      .unique {
        box-sizing: border-box;
        padding-left: 20px;
        margin: 30px 0 0 0;
      }
    }
  }

  @media (max-width: 1024px) {
    width: 100%;
    max-width: 720px;
    .item {
      width: 100%;

      &:not(:nth-child(1)) {
        padding: 30px 20px;
      }
    }
    .details {
      .details-img {
        .image {
          width: 100%;
          height: auto;
        }
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    max-width: 720px;
    // margin: 0 24px;

    .item {
      width: 100%;
    }
  }

  @media (width: 1024px) { 
    box-sizing: border-box;
    max-width: 960px;
    margin: 0 32px;

    .item {
      width: 610px;
    }
  }

  // @media (min-width: 1025px) {
  //   max-width: 1140px;
  // }
}
</style>